import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";

interface IProps {
  closeModal?: () => void;
}

const CrossModalHeader = ({ closeModal }: IProps) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: 32,
        marginBottom: 18
      }}
    >
      <Text size={18} style={{ fontWeight: 600 }}>{t("marginMode")}</Text>
      <CButton
        icon={<IconX size={18} color={textw} />}
        style={{
          color: textw,
          padding: 4,
          borderRadius: 50,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default CrossModalHeader;
